import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import { getRevisionsFailure, getRevisionsSuccess } from "./actions";
import { GET_REVISIONS } from "./constants";

export function* getRevisionsSaga({ payload, callback }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee/${payload}/onboarding/correction-fields`,
      payload
    );
    // Create a copy of the data to avoid direct mutation
    let dataCopy = JSON.parse(JSON.stringify(data));

    if (dataCopy && Array.isArray(dataCopy)) {
      dataCopy = dataCopy.map((item) => ({
        ...item,
        is_completed: false,
      }));
    }

    yield put(getRevisionsSuccess(dataCopy));
    typeof callback === "function" && callback(dataCopy);
  } catch (e) {
    yield put(getRevisionsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while getting revisions!"));
  }
}

export function* getRevisionsFlow() {
  yield takeEvery(GET_REVISIONS, getRevisionsSaga);
}
export default function* OnboardingRevisionSaga() {
  yield all([getRevisionsFlow()]);
}
